/** React Query cache keys — keep in sync anywhere scheduling data is fetched. */
export const SCHEDULING_INTEGRATION_QUERY_KEY = ['schedulingIntegration'];
export const SCHEDULING_SERVICES_QUERY_KEY = ['schedulingServices'];
export const SCHEDULING_HOSTS_QUERY_KEY = ['schedulingHosts'];

export const schedulingLeadMeetingsQueryKey = (leadId) => [
  'schedulingLeadMeetings',
  leadId
];

export const schedulingSlotsQueryKey = (leadId, date) => [
  'schedulingSlots',
  leadId,
  date
];

export const PROVIDER_LABELS = {
  pinggo: 'Pinggo'
};

export function providerLabel(provider) {
  return PROVIDER_LABELS[provider] || provider || 'scheduling backend';
}

export function isSchedulingConnected(data) {
  return data?.connected === true && data?.isActive === true;
}

export function supportsNativeBooking(data) {
  return isSchedulingConnected(data) && data?.capabilities?.nativeSlotBooking === true;
}

/** Calendly link-booking is not part of this Pinggo WhatsApp ship. */
export function supportsBookingLinks() {
  return false;
}

export function canScheduleAnything(data) {
  return supportsNativeBooking(data);
}

/** Short label for the Integration card button. */
export function schedulingStatusLabel(data, { isPending, isError } = {}) {
  if (isPending) return 'Checking…';
  if (isError || !data?.connected) return 'Connect';
  if (!data?.isActive) return 'Reconnect';
  return 'Connected';
}
